// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6e2f261d","239":"0be88566","455":"24c7f5ab"}[chunkId] + ".chunk.js";
};